import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=8b03f4de&scoped=true"
import script from "./Users.vue?vue&type=script&lang=js"
export * from "./Users.vue?vue&type=script&lang=js"
import style0 from "./Users.vue?vue&type=style&index=0&id=8b03f4de&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b03f4de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b03f4de')) {
      api.createRecord('8b03f4de', component.options)
    } else {
      api.reload('8b03f4de', component.options)
    }
    module.hot.accept("./Users.vue?vue&type=template&id=8b03f4de&scoped=true", function () {
      api.rerender('8b03f4de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/users/Users.vue"
export default component.exports